/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";

import Card from "@mui/material/Card";
import { formatDate, formatCurrency } from "utils";
import SoftBox from "components/SoftBox";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import DataTable from "./DataTable";
import ActionCell from "./components/ActionCell";
import { FixedAssetsInventorySummaryService } from "services/fixed-assets-inventory-summary";

const renderData = (items, setDataTable) => {
  return items.map((item) => {
    const invDateObj = item.inventoryDate ? new Date(item.inventoryDate) : new Date();
    const invDate = item.inventoryDate
      ? `${invDateObj.getDate().toString().padStart(2, "0")}/${(invDateObj.getMonth() + 1)
          .toString()
          .padStart(2, "0")}/${invDateObj.getFullYear()}`
      : "";

    return {
      id: item._id,
      documentNumber: item.inventoryCode || item.documentNumber || "",
      invDate,
      unit: item.company?.name || item.unit || "",
      department: item.inventoryCommittee?.[0]?.name || item.department || "",
      totalBookCost: item.totals?.accountingBookTotal?.originalCost
        ? formatCurrency.format(item.totals.accountingBookTotal.originalCost)
        : "0",
      totalDiffCost: item.totals?.varianceTotal?.originalCost
        ? formatCurrency.format(item.totals.varianceTotal.originalCost)
        : "0",
      createdAt: formatDate(item.createdAt),
      action: <ActionCell item={item} index={item._id} setDataTable={setDataTable} />,
    };
  });
};

const tableData = {
  columns: [
    {
      Header: "Số",
      accessor: "documentNumber",
    },
    {
      Header: "Ngày kiểm kê",
      accessor: "invDate",
    },
    {
      Header: "Đơn vị",
      accessor: "unit",
      width: "20%",
    },
    {
      Header: "Bộ phận",
      accessor: "department",
      width: "15%",
    },
    {
      Header: "Tổng nguyên giá sổ sách",
      accessor: "totalBookCost",
      width: "15%",
    },
    {
      Header: "Tổng chênh lệch nguyên giá",
      accessor: "totalDiffCost",
      width: "15%",
    },
    {
      Header: "Ngày tạo",
      accessor: "createdAt",
    },
    { Header: "Actions", accessor: "action", sorted: false },
  ],
  rows: [],
};

function FixedAssetsInventorySummary() {
  const [loading, setLoading] = useState(false);
  const [dataTable, setDataTable] = useState(tableData);
  const [query, setQuery] = useState({ sortBy: "createdAt", sortType: "desc" });
  const [checkCreate, setCheckCreate] = useState(true);
  const [paginationData, setPaginationData] = useState({
    page: 1,
    count: 0,
    size: 10,
  });

  useEffect(() => {
    fetchData();
  }, [query, paginationData.page]);

  const fetchData = async () => {
    try {
      setLoading(true);

      const response = await FixedAssetsInventorySummaryService.getPaginate({
        ...query,
        page: paginationData.page,
        size: paginationData.size,
      });

      const { items, checkCreate: createPerm, paginate } = response.data || response;
      setCheckCreate(createPerm ? false : true);
      setPaginationData((prev) => ({
        ...prev,
        count: paginate?.count || 0,
        size: paginate?.size || 10,
      }));

      setDataTable((prev) => ({
        ...prev,
        rows: renderData(items || [], setDataTable),
      }));

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Lỗi lấy dữ liệu Biên Bản Kiểm Kê TSCĐ:", error);
      setDataTable((prev) => ({ ...prev, rows: [] }));
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card style={{ height: "100%" }}>
          <DataTable
            checkCreate={checkCreate}
            query={query}
            table={dataTable}
            loading={loading}
            setQuery={setQuery}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

export default FixedAssetsInventorySummary;
